import { ISipping, Pagination, ShippingStatus, ShippingPriority } from '../../interfaces/deliveries.interface';

export namespace DeliveriesActions {
  export class GetDeliveries {
    static readonly type = '[Deliveries] Get Deliveries';
    constructor(
      public page?: number,
      public pageSize?: number,
      public status?: ShippingStatus,
      public priority?: ShippingPriority,
      public q?: string,
      public driverId?: number,
    ) {}
  }

  export class SetDeliveries {
    static readonly type = '[Deliveries] Set Deliveries';
    constructor(public deliveries: Pagination<ISipping>) {}
  }

  export class GetDeliveryById {
    static readonly type = '[Deliveries] Get Delivery By Id';
    constructor(public id: string) {}
  }

  export class UploadReceiptFile {
    static readonly type = '[Deliveries] Upload Receipt File';
    constructor(public shippingId: number, public receiptId: number, public file: File) {}
  }

  export class UploadReceiptFileSuccess {
    static readonly type = '[Deliveries] Upload Receipt File Success';
    constructor(public response: any) {}
  }

  export class UploadReceiptFileError {
    static readonly type = '[Deliveries] Upload Receipt File Error';
    constructor(public error: string) {}
  }

  export class HighlightRow {
    static readonly type = '[Deliveries] Highlight Row';
    constructor(public id: number | null) {}
  }

  export class PatchDelivery {
    static readonly type = '[Deliveries] Patch Delivery';
    constructor(public delivery: Partial<ISipping> & { id: number }) {}
  }
}
